import type { Permission } from "./types";

/**
 * Who may open a screen / see a menu entry (design/04 §14). `permission` = required; `anyOf` =
 * at least one of these (a screen serving several roles, e.g. products for staff *and* the
 * content editor). No rule = every signed-in staff member.
 */
export interface AccessRule {
  permission?: Permission;
  anyOf?: readonly Permission[];
}

export function allows(
  rule: AccessRule | undefined,
  can: (permission: Permission) => boolean,
): boolean {
  if (!rule) {
    return true;
  }
  if (rule.permission && !can(rule.permission)) {
    return false;
  }
  if (rule.anyOf && rule.anyOf.length > 0 && !rule.anyOf.some((p) => can(p))) {
    return false;
  }
  return true;
}
